"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToJSX = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Returns the name and, if applicable, the properties of a JSX object string


var tagDecoder = function tagDecoder(str) {
  var propList = str.split(" ");
  var name = propList.shift();
  var props = {};

  for (var index in propList) {
    if (propList[index] !== "") {
      var _propList$index$split = propList[index].split("="),
          _propList$index$split2 = _slicedToArray(_propList$index$split, 2),
          key = _propList$index$split2[0],
          val = _propList$index$split2[1];

      if (typeof val === 'string') {
        props[key] = val.substring(2, val.length - 2); // Issue if its a string {''} extra quotes
      } else if (_typeof(val) === 'object') {
        props[key] = JSON.parse(val.substring(1, val.length - 1));
      } else {
        props[key] = val.substring(1, val.length - 1);
      }
    }
  }

  return {
    "props": props,
    "name": name
  };
}; // Returns the name, props, and important indices for reference from a JSX object string


var indices = function indices(str) {
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var openTagStart = str.indexOf("<");
  var openTagEnd = str.indexOf(">", openTagStart);
  var contents = str.substring(openTagStart + 1, openTagEnd); // change to contents

  var selfClosing = contents.endsWith("/");
  if (selfClosing) contents = contents.substring(0, contents.length - 1).trim();

  var _tagDecoder = tagDecoder(contents),
      name = _tagDecoder.name,
      props = _tagDecoder.props;

  var closeTagStart = str.indexOf("</".concat(name, ">"));
  var closeTagEnd = str.indexOf(">", closeTagStart);
  var newName = components[name] ? components[name] : name;
  var status = openTagEnd !== -1 && newName !== "" && closeTagStart !== -1 && closeTagEnd !== -1 || selfClosing;
  return {
    "selfClosing": selfClosing,
    "status": status,
    "openTagStart": openTagStart,
    "openTagEnd": openTagEnd,
    "closeTagStart": closeTagStart,
    "closeTagEnd": closeTagEnd,
    "name": newName,
    "props": props
  };
}; // Returns the children of a JSX object string as a proper JSX object


var childParser = function childParser(str) {
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = [];

  var _indices = indices(str, components),
      selfClosing = _indices.selfClosing,
      status = _indices.status,
      name = _indices.name,
      openTagStart = _indices.openTagStart,
      openTagEnd = _indices.openTagEnd,
      closeTagStart = _indices.closeTagStart,
      closeTagEnd = _indices.closeTagEnd,
      props = _indices.props;

  if (!status) {
    alert("Malformed JSX");
    return str;
  }

  var leftchild = str.substring(0, openTagStart);
  var middlechild = selfClosing ? "" : str.substring(openTagEnd + 1, closeTagStart);
  var rightchild = str.substring(closeTagEnd + 1);

  if (leftchild.indexOf("<") > -1) {
    leftchild = childParser(leftchild, components);
  }

  if (middlechild.indexOf("<") > -1) {
    middlechild = childParser(middlechild, components);
  }

  if (rightchild.indexOf("<") > -1) {
    rightchild = childParser(rightchild, components);
  }

  if (leftchild !== "") result.push(leftchild);
  selfClosing ? result.push(_react.default.createElement(name, {})) : result.push(_react.default.createElement(name, props, middlechild));
  if (rightchild !== "") result.push(rightchild);
  return result.flat(Infinity);
};

var stringToJSX = function stringToJSX(str) {
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _indices2 = indices(str, components),
      selfClosing = _indices2.selfClosing,
      status = _indices2.status,
      name = _indices2.name,
      openTagStart = _indices2.openTagStart,
      openTagEnd = _indices2.openTagEnd,
      closeTagStart = _indices2.closeTagStart,
      closeTagEnd = _indices2.closeTagEnd,
      props = _indices2.props;

  if (selfClosing) return _react.default.createElement(name, props); // to allow JSX like <br />

  if (!status) {
    alert("Malformed JSX");
    return str;
  }

  var child = str.substring(openTagEnd + 1, closeTagStart);
  var result = child;

  if (child.indexOf("<") > -1) {
    result = childParser(child, components);
  }

  return _react.default.createElement(name, props, result);
};

exports.stringToJSX = stringToJSX;